import { View } from "react-native";
import React from "react";
import Dialog, { DialogProps } from "components/Dialog";
import { Text } from "@ui-kitten/components";
import i18n from "plugins/localization";

interface ConfirmPurchaseDialogPrpos extends DialogProps {
  amountDue: string | number;
}
const ConfirmPurchaseDialog: React.FC<ConfirmPurchaseDialogPrpos> = (props) => {
  const { visible, setVisible, amountDue, ...rest } = props;
  return (
    <Dialog visible={visible} setVisible={setVisible} {...rest}>
      <View style={{ padding: 5 }}>
        <Text category="h5">
          {i18n.t("screens.UpdateBilling.updatePaymentInterval")}
        </Text>
        <Text style={{ marginTop: 15 }}>
          {i18n.t("screens.UpdateBilling.currentPaymentInterval")}
        </Text>
        <Text category="h6">{i18n.t("screens.UpdateBilling.monthly")}</Text>

        <Text style={{ marginTop: 15 }}>
          {i18n.t("screens.UpdateBilling.pendingPaymentInterval")}
        </Text>
        <Text category="h6" status="danger">
          {i18n.t("screens.UpdateBilling.payInFull")}
        </Text>

        <Text style={{ marginTop: 15 }}>
          {i18n.t("screens.UpdateBilling.amountDue")}
        </Text>
        <Text category="h6" status="danger">
          {amountDue}
        </Text>
      </View>
    </Dialog>
  );
};

export default ConfirmPurchaseDialog;
